import { render, staticRenderFns } from "./BlockTimeSidebar.vue?vue&type=template&id=16a356b5&scoped=true&"
import script from "./BlockTimeSidebar.vue?vue&type=script&lang=js&"
export * from "./BlockTimeSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BlockTimeSidebar.vue?vue&type=style&index=0&id=16a356b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a356b5",
  null
  
)

export default component.exports